import { TemplateTypeDisplay } from "../../../core/entities/templateTypeDisplay";
import { TemplateTypeDto } from "../templateTypeDto";

export function mapDtoToTemplateTypes(
    templateTypeDto: TemplateTypeDto
): TemplateTypeDisplay {
    return {
        displayValue: templateTypeDto.displayValue,
        key: templateTypeDto.key
    };
}
